import React from "react";
import { Layers, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

function formatDate(d) {
  if (!d) return "";
  return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", timeZone: "Asia/Kolkata" });
}

const UpcomingBatches = ({ batches = [] }) => {
  const navigate = useNavigate();
  return (
    <div className="db-card">
      <div className="db-card-head">
        <div className="db-card-head-left">
          <div className="db-card-icon violet"><Layers size={18} /></div>
          <div>
            <div className="db-card-title">Upcoming Batches</div>
            <div className="db-card-subtitle">Starting soon</div>
          </div>
        </div>
        <button className="db-card-link" onClick={() => navigate("/batches")}>
          View All <ArrowRight size={12} />
        </button>
      </div>
      <div className="db-card-body">
        {batches.map((b, i) => (
          <div key={b.id || i} className="db-batch-card">
            <div className="db-batch-top">
              <span className="db-batch-name">{b.name}</span>
              <span className="db-batch-date-badge">{formatDate(b.date)}</span>
            </div>
            <div className="db-batch-meta">{b.course} · {b.instructor}</div>
            <div className="db-batch-progress-row">
              <div className="db-batch-progress-track">
                <div className="db-batch-progress-fill" style={{ width: `${Math.min((b.filled / b.seats) * 100, 100)}%` }} />
              </div>
              <span className="db-batch-seats">{b.filled}/{b.seats} seats</span>
            </div>
          </div>
        ))}
        {batches.length === 0 && <div className="text-muted text-center py-3" style={{ fontSize: "0.8125rem" }}>No upcoming batches</div>}
      </div>
    </div>
  );
};

export default UpcomingBatches;
